import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoanImagesComponent} from './loan-images.component';
import {LoanImagesRoutingModule} from './loan-images-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AuthGuard} from '../shared/guards/auth.guard';
import {MatIconModule, MatProgressSpinnerModule} from '@angular/material';

@NgModule({
  declarations: [
    LoanImagesComponent
  ],
  imports: [
    CommonModule,
    LoanImagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  providers: [
    AuthGuard
  ]
})
export class LoanImagesModule { }
